'use client';

import type { ReactNode } from 'react';
import type { HITLContentContext } from '../../tool-config-types';
import { TrackHistoryRequestHttpView } from './track-history-request-http-view';

export const renderTrackHistoryRequestHitlContent = (
  ctx: HITLContentContext,
): ReactNode => {
  if (!ctx.args) {
    return null;
  }

  return <TrackHistoryRequestHttpView input={ctx.args} showReviewMessage />;
};
